export const ODDS_TYPE_DROPDOWN = {
  tooltipDistance: 1
}